import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=7b1a6cd7&scoped=true&"
import script from "./ErrorCard.vue?vue&type=script&lang=ts&"
export * from "./ErrorCard.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=7b1a6cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a6cd7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon})
